import { Check, FileText, Square } from "lucide-react";
import { Link } from "react-router-dom";

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@src/shared/components/ui/alert";
import { Button } from "@src/shared/components/ui/button";

import type { SignUpProvisioningView } from "../../../domain/v2";

export function TrustStep({
  provisioningView,
}: {
  provisioningView: SignUpProvisioningView;
}) {
  const points = [
    {
      icon: FileText,
      title: "Used only for your note",
      body: "Audio and transcript produce your documentation, nothing else.",
    },
    {
      icon: Square,
      title: "Never used to train models",
      body: "Your patients' visits stay yours. They don't teach anyone's AI.",
    },
    {
      icon: Check,
      title: "You stay in control",
      body: "Nothing reaches your chart until you copy it in. You decide what's kept.",
    },
  ];

  return (
    <div className="flex w-full max-w-[416px] flex-col gap-2.5">
      {points.map((point) => (
        <div
          className="flex items-start gap-3 rounded-xl border border-border bg-background px-[14px] py-[13px] text-left"
          key={point.title}
        >
          <span className="flex size-8 shrink-0 items-center justify-center rounded-[9px] bg-primary/10 text-primary">
            <point.icon className="size-4" strokeWidth={2.1} aria-hidden />
          </span>
          <div>
            <p className="m-0 text-[13.5px] font-semibold text-foreground">
              {point.title}
            </p>
            <p className="m-0 mt-0.5 text-[12.5px] leading-[1.5] text-muted-foreground">
              {point.body}
            </p>
          </div>
        </div>
      ))}

      {provisioningView.state === "failed" ? (
        <Alert className="mt-2 text-left" variant="destructive">
          <AlertTitle>{provisioningView.title}</AlertTitle>
          <AlertDescription>
            <p>{provisioningView.description}</p>
            {provisioningView.requestId ? (
              <p className="mt-2 font-mono text-xs">
                Reference: {provisioningView.requestId}
              </p>
            ) : null}
            <div className="mt-3 flex flex-wrap gap-2">
              {provisioningView.signInHref ? (
                <Button asChild size="sm" variant="outline">
                  <Link to={provisioningView.signInHref}>Sign in instead</Link>
                </Button>
              ) : null}
              <Button asChild size="sm" variant="outline">
                <a href={provisioningView.supportHref}>Contact support</a>
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      ) : null}
    </div>
  );
}
